import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { IHTMLDiv, IHTMLInput } from "../interfaces/InputsInterfacesType1";
import { IInputValidationItemController } from "../../../../factorys/inputvalidation/interfaces/InputValidationInterfaces";


/**
 * works for;
 * TextInput, SelectInput
 */
interface IProps<T> {
  value: T | undefined;
  disabled?: boolean | undefined;
  classNameInput?: string;
  classNameFrame?: string;
  disabledClass: string;
  onMount?: (() => void);
}
interface IReturnProps<T>  extends IInputValidationItemController {
  blur: boolean; setBlur: Dispatch<SetStateAction<boolean>>;
  setRefFrame: (it: IHTMLDiv | null) => void,
  refInput: IHTMLInput | null, setRefInput: (it: IHTMLInput | null) => void,
  value: T | undefined, setValue: Dispatch<T>
}
export const InputControllerType1 = <T>(props: IProps<T>): IReturnProps<T> => {
  
  const tag = " InputControllerType1";
  //console.log(tag + " START");

  const [blur, setBlur] = useState<boolean>(false);


  const [value, setValue] = useState<T | undefined>(props.value);
  useEffect(() => {
    //console.log("value: " +value)
  }, [value]);
 

  //refs
  let refFrame: IHTMLDiv | null = null;
  function setRefFrame(it: IHTMLDiv | null) {
    try {
      if (it == null) return;
      refFrame = it;
      setDisabled(props.disabled);
    } catch (e) {}
  }

  let refInput: IHTMLInput | null = null;
  function setRefInput(it: IHTMLInput | null) {
    try {
      if (it == null) return;
      refInput = it;
      setDisabled(props.disabled);
    } catch (e) {}
  }
  //states


  //init
  useEffect(() => {
    //console.log(tag + " => onMount");
    setDisabled(props.disabled);

    props.onMount? props.onMount():null
    //setDisabled(true)
    return () => {
      //console.log(tag + " => onUnmount");
    };
  }, []);


  useEffect(() => {
    try {
      setDisabled(props.disabled);
    } catch (e) {}
  }, [props.disabled]);


  function setDisabled(disabled: boolean = true) {
    if(refFrame != null) {
      try {
        refFrame.className = disabled ? (props.classNameFrame + " " + props.disabledClass) : props.classNameFrame!!;
      } catch (e) {
        refFrame!!.className = disabled ? (props.disabledClass) : "";
      }
    }

    if(refInput != null) {
      try {
          refInput.disabled = disabled;
          refInput.className = disabled ? (props.classNameInput!! + " " + props.disabledClass) : props.classNameInput!!;
        } catch (e) {
          refFrame!!.className = disabled ? (props.disabledClass) : "";
        } 
    }
  }

  return { 
    blur, setBlur,
    setRefFrame, 
    refInput, setRefInput,
    value, setValue
  };
}